import { Component, EventEmitter, Output } from '@angular/core';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { Observable, Subject, Subscription, interval } from 'rxjs';
import { debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelectChange } from '@angular/material/select';
import { CustomService } from 'src/app/core/services/custom.service'
import { BrdCpcFormComponent } from '../brd-cpc-form/brd-cpc-form.component';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-brd-diary-cpc',
  templateUrl: './brd-diary-cpc.component.html',
  styleUrls: ['./brd-diary-cpc.component.css']
})
export class BrdDiaryCPCComponent {

  brddata?: any = [];
  dateLabel: string | null = null;
  selectedDate: Date | null = null;
  inputText: string | null = null;
  // private textChangeSubject = new Subject<string>();
  private subscription: Subscription;
  selectedData: string | null = null;
  tabSelected: string | null = 'brd';
  showSupcodeInput = false;
  // EventEmitter สำหรับส่งค่าจาก Component A ไป Component B
  @Output() reportdate = new EventEmitter<string>();
  @Output() supcode = new EventEmitter<string>();
  @Output() dateSelected = new EventEmitter<Date>();
  @Output() textSent = new EventEmitter<string>();

  constructor(
    private brdservice: BrdsqlService,
    private spinner: NgxSpinnerService,
    private custService: CustomService,
  ) {

  }

  ngOnInit(): void {
  }

  sendDate(): void {
    if (this.selectedDate) {
      const date: string = this.custService.Date2en(this.selectedDate);
      const supcode: string | null = this.inputText;
      this.getDateToday(date);
      this.getBrdDiaryCPC(date);
    }
  }

  onDateChange(e) {
    let date = e.target.value
    date = this.custService.Date2en(date)
    this.reportdate = date;
    this.getDateToday(date);
    // console.log('reportdate :', this.reportdate);
  }

  getDateToday(date: string) {
    const today = new Date(date);
    const thaiDate = today.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    });
    this.dateLabel = thaiDate;
    // console.log('thaiDate :' ,thaiDate);
  }

  onSelectChange(event: MatSelectChange): void {
    this.selectedData = event.value;
    console.log('คุณเลือก:', this.selectedData);
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.index == 1) {
      this.showSupcodeInput = true;
    } else {
      this.showSupcodeInput = false;
    }
    // console.log('คุณคลิกที่แท็บ:', event.index);
    // console.log('ชื่อแท็บ:', event.tab.textLabel);
  }

  onSupcodeInput() {
    const supcode: any = this.inputText;
    this.supcode = supcode;
    // console.log('supcode :', this.supcode);
  }

  async getBrdDiaryCPC(date: string) {
    this.spinner.show()
    this.subscription = await this.brdservice.getBrdCPCDiaryReport(date)
      .subscribe({
        next: (res) => {
          // console.log('res :', res);
          if (res.code !== "EREQUEST") {
            this.brddata = res.recordset[0]
            console.log('brddata :', this.brddata);
          } else {
            alert('!!ไม่พบข้อมูลของวันที่ดังกล่าว')
            this.brddata = []
          }
        }, error(err) {
          console.log('err:', err)
        }, complete: () => {
          // console.log('complete');
          this.spinner.hide();
        },
      })
  }

  printPage() {
    window.print();
  }

  ngOnDestroy(): void {
    // Unsubscribe เมื่อ Component ถูกทำลาย
    if (this.subscription) {
      this.subscription.unsubscribe();
      console.log('Unsubscribed!');
    }
  }

}
